// extracted by mini-css-extract-plugin
module.exports = {"headshot":"_9d839498","image":"_b846c0d7"};